var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "load-cell" }, [
    !_vm.record.isSumRow &&
    _vm.record.postCode !== "driver" &&
    !_vm.record.loadType.is_system
      ? _c(
          "div",
          { staticClass: "load-cell-value load-cell-value-hover" },
          [
            _c("c-input", {
              staticClass: "load-cell-value-input",
              attrs: { placeholder: "0", type: "price-number" },
              model: {
                value: _vm.localCellLocalValue,
                callback: function ($$v) {
                  _vm.localCellLocalValue = $$v
                },
                expression: "localCellLocalValue",
              },
            }),
          ],
          1
        )
      : _c("div", { staticClass: "load-cell-value" }, [
          _vm._v(_vm._s(_vm.record.load.value)),
        ]),
    _c("div", { staticClass: "load-cell-unit" }, [
      _vm._v(_vm._s(_vm.record.load.unit)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }